import styled from 'astroturf/react';
import s from '../Capbox.styles';

const CapboxKeyMilestoneDatesWrapper = styled('div')`
    display: flex;
    flex-direction: column;
    padding: 15px;
    border: .5px solid var(--ph-gray-250);
    background: var(--white);
    margin-bottom: 20px;
`;

const CapboxKeyMilestoneDatesTitle = styled('h2')`
    font-size: var(--ph-text-md);
    font-family: var(--ph-font-family-lato-heavy);
    color: var(--dark-blue);
    float: left;
    width: 100%;
`;

const CapboxKeyMilestoneDatesSubTitle = styled('div')`
    font-size: var(--ph-text-sm);
    font-family: var(--ph-font-family-lato-heavy);
    color: var(--dark-blue);
`;

const CapboxKeyMilestoneDatesLegend = styled('div')`
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
`;

const CapboxKeyMilestoneDatesDesc = styled('div')`
    font-size: 11px;
    font-family: var(--ph-font-family-source-sans-pro-semibold);
    color: var(--dark-blue);
`;

const CapboxKeyMilestoneDatesLegendDetails = styled('div')`
    font-size: 11px;
    font-family: var(--ph-font-family-source-sans-pro-regular);
    color: var(--dark-blue);
    margin-left: 15px;
    display: flex;
    flex-direction: row;
`;

const CapboxKeyMilestoneDimondIcon = styled('div')`
    background: var(--cyan-green);
    height: 10px;
    text-align: center;
    transform: rotate(45deg);
    width: 10px;
    border: 1px solid var(--dark-blue);
    margin-top: 8px;
    margin-right: 5px;
`;

export default {
    ...s,
    CapboxKeyMilestoneDatesWrapper,
    CapboxKeyMilestoneDatesTitle,
    CapboxKeyMilestoneDatesSubTitle,
    CapboxKeyMilestoneDatesLegend,
    CapboxKeyMilestoneDatesDesc,
    CapboxKeyMilestoneDatesLegendDetails,
    CapboxKeyMilestoneDimondIcon
}  
